// extracted by mini-css-extract-plugin
export default {"header":"DashboardContainer_header__8OTT5","layout":"DashboardContainer_layout__MqUEX","sider":"DashboardContainer_sider__yRfCp","title":"DashboardContainer_title__jDXh0"};